import { render } from "./TemplateSettingMenu.vue?vue&type=template&id=794bf3ee"
import script from "./TemplateSettingMenu.vue?vue&type=script&lang=js"
export * from "./TemplateSettingMenu.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__